//TODO: move into session/state directory when get around to refactoring

import actionTypes from "../action-types";
import sessionModuleActionTypes from "../action-types/sessionModule";
import SessionModule from "../models/SessionModule";

export function reconcileSessionProficiencies(
  sessionId: string,
  startingProficiency: number,
  endingProficiency: number,
  startingCourseProficiency: number,
  endingCourseProficiency: number
) {
  return {
    type: actionTypes.RECONCILE_SESSION_PROFICIENCIES,
    payload: {
      sessionId,
      startingProficiency,
      endingProficiency,
      startingCourseProficiency,
      endingCourseProficiency
    }
  };
}

export function setWonMemory({
  sessionId,
  wonMemory
}: {
  sessionId: string;
  wonMemory: boolean;
}) {
  return {
    type: actionTypes.SET_WON_MEMORY,
    payload: {
      sessionId,
      wonMemory
    }
  };
}

// Session Module
export function newSessionModule(
  sessionId: string,
  sessionModuleId: string,
  sessionModule: SessionModule,
  timestamp: string
) {
  return {
    type: sessionModuleActionTypes.NEW_SESSION_MODULE,
    payload: {
      sessionId,
      sessionModuleId,
      sessionModule,
      timestamp
    }
  };
}

export function updateAnswer(
  sessionId: string,
  sessionModuleId: string,
  answer: any
) {
  return {
    type: sessionModuleActionTypes.UPDATE_ANSWER,
    payload: {
      answer,
      sessionId,
      sessionModuleId
    }
  };
}

export const updateModuleState = (
  sessionId: string,
  sessionModuleId: string,
  param: any | ((oldState: any) => any)
) => {
  return {
    type: sessionModuleActionTypes.UPDATE_MODULE_STATE,
    payload: {
      sessionId,
      sessionModuleId,
      ...(typeof param === "function"
        ? { updateState: param }
        : { state: param })
    }
  };
};

export function giveUp(sessionId: string, sessionModuleId: string) {
  return {
    type: sessionModuleActionTypes.GIVE_UP,
    payload: {
      sessionId,
      sessionModuleId
    }
  };
}
